export default  [
  {
    key: "owner",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract",
    label: "Contract",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },

  {
    key: "tag",
    label: "Tag Number",
    sortable: false
  },

  {
    key: "lastupdate",
    label: "Lastupdate",
    sortable: true
  },

]